/* eslint-disable no-nested-ternary */
import React, { useState, useEffect, useMemo } from "react";
import { useForm, Controller } from "react-hook-form";
import { withRouter, useHistory } from "react-router-dom";
import {
  Alert,
  BackButton,
  Breadcrumbs,
  Text,
  MandatoryFieldText,
  InputContainer,
  SendToast,
  Wrapper,
} from "@networkraildigitalfactory/components";
import emojiStrip from "emoji-strip";
import { Select } from "antd";
import FYValuesSelect from "../DropdownValuesSelect/FYValuesSelect";
import PeriodValuesSelect from "../DropdownValuesSelect/PeriodValuesSelect";
import "../CreateObjective/AntD.css";
import "./AntD.css";
import styles from "../CreateObjective/CreateObjective.module.css";
import SliderSelect from "../SliderSelect/SliderSelect";
import RadioSelect from "../RadioSelect/RadioSelect";
import CreateOneToOneButtons from "./CreateOneToOneButtons";
import EditOneToOneButtons from "./EditOneToOneButtons";
import { useUsers, useOneToOnes, useObjectives, usePDP } from "../../hooks/useAPI";
import MultiSelectNoContent from "../MultiSelectNoContent/MultiSelectNoContent";
import {
  a11yGrowTextarea,
  getBuild,
  getCurrentFinancialYear,
  preventFormDefault,
} from "../../services/utils";
import StatusLabel from "../StatusLabel/StatusLabel";
import useUser from "../../hooks/useUser";

const { Option } = Select;
const CreateOneToOne = (props) => {
  const { isGBR } = useUser();
  const { webUrl } = getBuild();
  const { editMode, user, isDirtyForm, setIsDirtyForm, setNavModalProps } = props;

  const [oneToOnesYearPeriodPairs, setOneToOnesYearPeriodPairs] = useState();
  const [isDisableActions, setIsDisableActions] = useState(false);
  const [, executePost] = useOneToOnes(
    {
      method: "GET",
    },
    { manual: true }
  );

  const questionsContent = {
    gbr: {
      success:
        "What would you like to celebrate? (please share your success since your last 1-2-1 here)",
      challenge: "What have you found challenging? What do you need to help you progress?",
    },
    nr: {
      success:
        "What are some of your biggest successes since your last 1-2-1? (Is there anything you want to celebrate?)",
      challenge: "What have you found challenging? (Is there anything preventing your progress?)",
    },
  };

  const questions = useMemo(() => {
    if (isGBR) return questionsContent.gbr;
    return questionsContent.nr;
  }, [isGBR, questionsContent]);

  const fetchOneToOnesData = async ({ userData }) => {
    const result = await executePost({
      data: {
        user: userData,
      },
    });

    setOneToOnesYearPeriodPairs(
      result.data.map((o2o) => {
        if (o2o._id !== props.match.params.id) {
          return `${o2o.financialYear}-${o2o.period}`;
        }
        return null;
      })
    );
  };

  const history = useHistory();
  const {
    setValue,
    getValues,
    control,
    clearError,
    register,
    setError,
    errors,
    triggerValidation,
  } = useForm({});
  const [oneToOneValues, setOneToOneValues] = useState({});
  const [objectivesData, setObjectivesData] = useState();
  const [showObjectives, setShowObjectives] = useState(false);
  const [developmentGoalsData, setDevelopmentGoalsData] = useState();
  const [showDevelopmentGoals, setShowDevelopmentGoals] = useState(false);

  const navTo = (dest) => props.history.push(dest);

  const reValidate = () => {
    if (Object.keys(errors).length > 0) {
      triggerValidation();
    }
  };

  const inputKeydown = () => {
    setIsDirtyForm(true);
    reValidate();
  };

  const onSelectPeriod = () => {
    setIsDirtyForm(true);
  };

  const switchToastMessage = (type) => {
    switch (type) {
      case "draft":
        return "Your 1-2-1 prep has been saved";
      case "edited":
        return "Updates have been saved to draft 1-2-1 prep";
      case "submitted":
        return "Your 1-2-1 prep has been successfully submitted";
      case "error":
        return "There was a problem updating your 1-2-1 prep. Please try again.";
      case "error-create":
        return "There was a problem with your 1-2-1 prep. Please correct financial year and/or period and try again.";
      default:
        return "";
    }
  };

  const [, getUser] = useUsers(user.email);

  const [, getObjectives] = useObjectives(
    {
      method: "GET",
    },
    {
      manual: true,
    }
  );

  const [, getDevelopmentGoals] = usePDP(
    {
      method: "GET",
    },
    {
      manual: true,
    }
  );

  const fetchObjectivesData = async () => {
    try {
      const result = await getObjectives({
        url: "1-2-1",
      });

      const objectives = [];

      result.data.forEach((item) => {
        const hiddenStatuses = ["draft", "closed", "cancelled"];
        objectives.push(
          <Option
            style={{
              display: hiddenStatuses.includes(item.status) ? "none" : "block",
            }}
            key={item._id}
          >
            {item.name}
          </Option>
        );
      });
      setObjectivesData(objectives);
    } catch (error) {
      console.error("Failed to fetch data:", error);
    }
  };

  const fetchDevelopmentGoalsData = async () => {
    try {
      const result = await getDevelopmentGoals({
        url: "1-2-1",
      });

      const developmentGoals = [];

      result.data.forEach((item) => {
        const hiddenStatuses = ["draft", "closed", "cancelled"];
        developmentGoals.push(
          <Option
            style={{
              display: hiddenStatuses.includes(item.status) ? "none" : "block",
            }}
            key={item._id}
          >
            {item.name}
          </Option>
        );
      });
      setDevelopmentGoalsData(developmentGoals);
    } catch (error) {
      console.error("Failed to fetch data:", error);
    }
  };

  const buildPayload = (data) => {
    const ret = {
      status: data.status || "",
      email: data.email,
      period: data.period || "",
      financialYear: data.financialYear,
      prep: {
        successDesc: data.successDesc || "",
        challengesDesc: data.challengesDesc || "",
        objectives: data.objectives || [],
        discussObjective: oneToOneValues.discussObjective || false,
        objectivesDesc: data.objectivesDesc || "",
        developmentGoals: data.developmentGoals || [],
        discussDevelopmentGoal: oneToOneValues.discussDevelopmentGoal || false,
        developmentGoalsDesc: data.developmentGoalsDesc || "",
        isPrepCompleted: data.isPrepCompleted || false,
        isPrepStarted: true,
        wellBeingFeeling: oneToOneValues.wellBeingFeeling || 0,
        additionalComments: data.additionalComments || "",
      },
      comments: data.comments || [],
      additionalLmFeedback: data.additionalLmFeedback || "",
      lmFeedback: data.lmFeedback || "",
      isCompleted: data.isCompleted || false,
    };
    return ret;
  };

  const [{ error: postError }, postData] = useOneToOnes(
    {
      method: "POST",
    },
    { manual: true }
  );

  const [{ error: errPut }, updateOneToOne] = useOneToOnes(
    {
      url: props.match.params.id,
      method: "PUT",
    },
    { manual: true }
  );

  const saveToCloud = async (data) => {
    return new Promise((resolve, reject) => {
      try {
        postData({ data })
          .then(() => {
            getUser().then((userData) => {
              props.updateUser(userData.data);
              if (postError) {
                reject();
              }
              resolve();
            });
          })
          .catch(function () {
            clearError("financialYear");
            setError("financialYear", "", "Must be a different financial year");
            clearError("period");
            setError("period", "", "Must be a different period");
            SendToast(switchToastMessage("error-create"), "error");
          });
      } catch (err) {
        SendToast(switchToastMessage("error"), "error");
        reject();
      }
    });
  };

  const onSubmit = async (data) => {
    const isValid = await triggerValidation();
    if (isValid) {
      data.status = "submitted";
      data.isPrepCompleted = true;
      data.email = user.email;

      saveToCloud(buildPayload(data)).then(() => {
        SendToast(switchToastMessage(data.status), "success");
        navTo("/my-1-2-1s");
      });
    }
  };

  const onSave = (e) => {
    e.preventDefault();
    const formData = getValues();
    formData.status = "draft";
    formData.email = user.email;

    formData.discussDevelopmentGoal = formData.discussDevelopmentGoal
      ? formData.discussDevelopmentGoal
      : "";
    formData.discussObjective = formData.discussObjective ? formData.discussObjective : "";
    formData.wellBeingFeeling = formData.wellBeingFeeling ? formData.wellBeingFeeling : "";

    const { period, financialYear } = formData;

    if (!period || !financialYear) {
      clearError("period");
      setError("period", "", "Must not be blank");
    } else {
      saveToCloud(buildPayload(formData)).then(() => {
        SendToast("Your 1-2-1 prep has been saved as a draft", "success");
        navTo("/my-1-2-1s");
      });
    }
  };

  const onSaveDraft = async (e) => {
    e.preventDefault();
    const formData = getValues();
    formData.status = "draft";
    formData.email = user.email;
    formData.discussDevelopmentGoal = formData.discussDevelopmentGoal
      ? formData.discussDevelopmentGoal
      : "";
    formData.discussObjective = formData.discussObjective ? formData.discussObjective : "";
    formData.wellBeingFeeling = formData.wellBeingFeeling ? formData.wellBeingFeeling : "";

    const { period, financialYear } = formData;

    if (!period || !financialYear) {
      clearError("period");
      setError("period", "", "Must not be blank");
    } else {
      await updateOneToOne({ data: buildPayload(formData) });
      setIsDirtyForm(false);
      SendToast("Your 1-2-1 prep has been saved as a draft", "success");
      history.push(`/my-1-2-1s`);
    }
  };

  const onEdit = async (data) => {
    const isValid = await triggerValidation();
    if (isValid) {
      data.status = "submitted";
      data.isPrepCompleted = true;
      await updateOneToOne({ data: buildPayload(data) });
      setIsDirtyForm(false);
      SendToast(switchToastMessage("submitted"), "success");
      history.push(`/my-1-2-1s`);
    }
  };

  const onInputChange = (field, value) => {
    let alreadyUsed = "";
    if (oneToOnesYearPeriodPairs && ["period", "financialYear"].includes(field)) {
      const formData = getValues();
      const { period, financialYear } = formData;
      const o2oPeriod = field === "period" ? `${financialYear}-${value}` : `${value}-${period}`;
      alreadyUsed = oneToOnesYearPeriodPairs.find((o) => o2oPeriod === o);
      if (alreadyUsed !== undefined) {
        clearError("financialYear");
        setError("financialYear", "", "");
        clearError("period");
        setError("period", "", "");
        setIsDisableActions(true);
      } else {
        setIsDisableActions(false);
        clearError("financialYear");
        clearError("period");
      }
    }
    setOneToOneValues((prevFormValues) => ({
      ...prevFormValues,
      [field]: emojiStrip(value),
    }));
  };

  const [, getData] = useOneToOnes(
    {
      method: "GET",
      url: props.match.params.id,
    },
    {
      manual: true,
    }
  );

  const fetchData = async () => {
    if (props.match.params.id === undefined) return;

    const result = await getData();
    if (result) {
      const savedOneToOne = result.data;
      if (savedOneToOne.prep.objectives.length > 0) {
        await fetchObjectivesData();
      }
      if (savedOneToOne.prep.developmentGoals.length > 0) {
        await fetchDevelopmentGoalsData();
      }

      setOneToOneValues({
        ...savedOneToOne,
        challengesDesc: savedOneToOne.prep.challengesDesc,
        discussObjective: savedOneToOne.prep.discussObjective,
        objectives: savedOneToOne.prep.objectives,
        objectivesDesc: savedOneToOne.prep.objectivesDesc,
        discussDevelopmentGoal: savedOneToOne.prep.discussDevelopmentGoal,
        developmentGoals: savedOneToOne.prep.developmentGoals,
        developmentGoalsDesc: savedOneToOne.prep.developmentGoalsDesc,
        successDesc: savedOneToOne.prep.successDesc,
        wellBeingFeeling: savedOneToOne.prep.wellBeingFeeling,
        additionalComments: savedOneToOne.prep.additionalComments,
      });
      setValue("financialYear", savedOneToOne.financialYear);
      setValue("period", savedOneToOne.period);
      if (savedOneToOne.prep.objectives.length > 0) {
        setShowObjectives(true);
        setValue("objectives", savedOneToOne.prep.objectives);
        setValue("discussObjective", savedOneToOne.prep.discussObjective);
      }
      if (savedOneToOne.prep.developmentGoals.length > 0) {
        setShowDevelopmentGoals(true);
        setValue("developmentGoals", savedOneToOne.prep.developmentGoals);
        setValue("discussDevelopmentGoal", savedOneToOne.prep.discussDevelopmentGoal);
      }
    }
  };

  useEffect(() => {
    fetchOneToOnesData(user);
    setValue("discussObjective", oneToOneValues.discussObjective);
    setValue("discussDevelopmentGoal", oneToOneValues.discussDevelopmentGoal);
    onInputChange("discussObjective", "false", false);
    onInputChange("discussDevelopmentGoal", "false", false);
    if (props.match.params.year && props.match.params.period) {
      const formattedYear = props.match.params.year.replace("-", "/");
      setValue("financialYear", formattedYear);
      onInputChange("financialYear", formattedYear, false);
      setValue("period", props.match.params.period);
      onInputChange("period", props.match.params.period, false);
    }
    fetchData();
  }, []);

  const handleDiscussObjectivesChange = (e) => {
    const selection = e.target.value === "true";
    if (e.target.name === "discussObjective") {
      setShowObjectives(selection);
      setOneToOneValues((prevFormValues) => ({
        ...prevFormValues,
        discussObjective: selection,
      }));
      if (selection === true) fetchObjectivesData();
    }
    if (e.target.name === "discussDevelopmentGoal") {
      setShowDevelopmentGoals(selection);
      setOneToOneValues((prevFormValues) => ({
        ...prevFormValues,
        discussDevelopmentGoal: selection,
      }));
      if (selection === true) fetchDevelopmentGoalsData();
    }
    setIsDirtyForm(true);
  };

  const handleObjectivesSelection = (selected) => {
    const updatedData = selected;
    setOneToOneValues((prevFormValues) => ({
      ...prevFormValues,
      objectives: updatedData,
    }));
    setIsDirtyForm(true);
  };

  const getDropdownFinancialYear = () => {
    const selectedValue = oneToOneValues.financialYear;
    return selectedValue;
  };

  const getDropdownPeriodValue = () => {
    const selectedValue = oneToOneValues.period;
    return selectedValue;
  };

  const handleWellbeingSelection = (selected) => {
    setOneToOneValues((prevFormValues) => ({
      ...prevFormValues,
      wellBeingFeeling: selected,
    }));
    setIsDirtyForm(true);
  };

  if (errPut) return SendToast("Your 1-2-1 prep hasn't been updated. Please try again", "error");

  return (
    <>
      <div className={styles.breadcrumbs_wrapper}>
        <Breadcrumbs
          items={[
            {
              text: "My 1-2-1s",
              onClick: () => {
                if (isDirtyForm) {
                  setNavModalProps({
                    show: true,
                    navPath: "/my-1-2-1s",
                  });
                } else {
                  navTo("/my-1-2-1s");
                }
              },
            },
            {
              text: `${
                editMode && oneToOneValues.status === "submitted"
                  ? "Edit 1-2-1 prep notes"
                  : "Prep for your next 1-2-1"
              }`,
            },
          ]}
        />
      </div>
      <Wrapper maxWidth={1350} align="center">
        {(isDirtyForm || isDisableActions) && (
          <Alert
            color="red"
            title={isDisableActions ? "Prep already saved" : "Unsaved Changes"}
            message={
              isDisableActions
                ? "You have already saved prep for this period within the selected financial year. Please select a different financial year or period."
                : "You must save or submit your changes before navigating to another page. If you do not select save, all changes will be lost."
            }
            style={{
              lineHeight: "140%",
              letterSpacing: "0.0015em",
              padding: "8px 10px 8px 10px",
            }}
          />
        )}
        <div className={styles.row}>
          <BackButton
            text="back to 1-2-1s"
            onClick={() => {
              if (isDirtyForm) {
                setNavModalProps({
                  show: true,
                  navPath: "/my-1-2-1s",
                });
              } else {
                navTo("/my-1-2-1s");
              }
            }}
            style={{ lineHeight: "140%", letterSpacing: "0.0015em" }}
          />
          {editMode && (
            <StatusLabel
              status={oneToOneValues && oneToOneValues.status !== "draft" ? "Editing" : "Draft"}
            />
          )}
        </div>
        <div className={styles.light_bg}>
          <Text
            type="header"
            wrapper="h2"
            style={{ lineHeight: "140%", letterSpacing: "0.0015em" }}
          >
            1-2-1 Prep
          </Text>
          <MandatoryFieldText />
          <form className={styles.form} role="presentation">
            <div className={styles.input_row}>
              <InputContainer
                labelText="Financial year for this 1-2-1"
                forLabel="financialYear"
                required
                errorText={errors.financialYear && errors.financialYear.message}
              >
                {oneToOneValues && (
                  <Controller
                    as={
                      <FYValuesSelect
                        className={`${styles.form_input} ${
                          errors.financialYear ? styles.error : ""
                        }`}
                        value={
                          oneToOneValues && oneToOneValues.financialYear
                            ? oneToOneValues.financialYear
                            : getCurrentFinancialYear()
                        }
                      />
                    }
                    name="financialYear"
                    valueName="financialYear"
                    onChange={([selected]) => {
                      onSelectPeriod();
                      inputKeydown();
                      onInputChange("financialYear", selected, false);
                      return selected;
                    }}
                    control={control}
                    rules={{
                      required: "Must not be blank",
                    }}
                    defaultValue={editMode ? getDropdownFinancialYear() : getCurrentFinancialYear()}
                  />
                )}
                {!oneToOneValues && (
                  <Controller
                    as={
                      <FYValuesSelect
                        className={`${styles.form_input} ${
                          errors.financialYear ? styles.error : ""
                        }`}
                        value={getCurrentFinancialYear()}
                      />
                    }
                    name="financialYear"
                    valueName="financialYear"
                    onChange={([selected]) => {
                      onSelectPeriod();
                      inputKeydown();
                      onInputChange("financialYear", selected, false);
                      return selected;
                    }}
                    control={control}
                    rules={{
                      required: "Must not be blank",
                    }}
                    defaultValue={getCurrentFinancialYear()}
                  />
                )}
              </InputContainer>
              <InputContainer
                labelText="Period for this 1-2-1"
                forLabel="period"
                required
                errorText={errors.period && errors.period.message}
              >
                {oneToOneValues && (
                  <Controller
                    as={
                      <PeriodValuesSelect
                        className={`${styles.form_input} ${errors.period ? styles.error : ""}`}
                        value={oneToOneValues?.period || ""}
                      />
                    }
                    name="period"
                    valueName="period"
                    onChange={([selected]) => {
                      onSelectPeriod();
                      inputKeydown();
                      onInputChange("period", selected, false);
                      return selected;
                    }}
                    control={control}
                    rules={{
                      required: "Must not be blank",
                    }}
                    defaultValue={editMode && getDropdownPeriodValue()}
                  />
                )}
                {!oneToOneValues && (
                  <Controller
                    as={
                      <PeriodValuesSelect
                        className={`${styles.form_input} ${errors.period ? styles.error : ""}`}
                      />
                    }
                    name="period"
                    valueName="period"
                    onChange={([selected]) => {
                      onSelectPeriod();
                      inputKeydown();
                      onInputChange("period", selected, false);
                      return selected;
                    }}
                    control={control}
                    rules={{
                      required: "Must not be blank",
                    }}
                  />
                )}
              </InputContainer>
            </div>

            <div className={styles.textarea_wrapper}>
              <InputContainer
                labelText={questions.success}
                required
                forLabel="successDesc"
                errorText={errors.successDesc && errors.successDesc.message}
              >
                <textarea
                  name="successDesc"
                  onPaste={inputKeydown}
                  className={`${styles.form_textarea} ${errors.successDesc ? styles.error : ""}`}
                  id="successDesc"
                  ref={register({
                    required: "Must not be blank",
                  })}
                  defaultValue={
                    editMode && oneToOneValues && oneToOneValues.successDesc
                      ? oneToOneValues.successDesc
                      : ""
                  }
                  onChange={(e) => {
                    inputKeydown();
                    onInputChange("successDesc", e.target.value, false);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      onInputChange("successDesc", e.target.value, true);
                    }
                    a11yGrowTextarea(e, "successDesc");
                  }}
                />
              </InputContainer>
              <InputContainer
                labelText={questions.challenge}
                required
                forLabel="challengesDesc"
                errorText={errors.challengesDesc && errors.challengesDesc.message}
              >
                <textarea
                  name="challengesDesc"
                  id="challengesDesc"
                  onPaste={inputKeydown}
                  className={`${styles.form_textarea} ${errors.challengesDesc ? styles.error : ""}`}
                  defaultValue={
                    editMode && oneToOneValues && oneToOneValues.challengesDesc
                      ? oneToOneValues.challengesDesc
                      : ""
                  }
                  onChange={(e) => {
                    inputKeydown();
                    onInputChange("challengesDesc", e.target.value, false);
                  }}
                  ref={register({
                    required: "Must not be blank",
                  })}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      onInputChange("challengesDesc", e.target.value, true);
                    }
                    a11yGrowTextarea(e, "challengesDesc");
                  }}
                />
              </InputContainer>
              <InputContainer
                labelText="Is there any particular objective(s) you would like to discuss at this 1-2-1?"
                required
                forLabel="discussObjective"
                errorText={errors.discussObjective && errors.discussObjective.message}
              >
                <a
                  className={styles.link}
                  href={`${webUrl}/my-objectives/objectives`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Click here to view your objectives
                </a>
                <Controller
                  as={
                    <RadioSelect
                      onObjectivesToDiscussChange={handleDiscussObjectivesChange}
                      value={`${oneToOneValues.discussObjective}`}
                      name="discussObjective"
                    />
                  }
                  defaultValue={
                    editMode && oneToOneValues && oneToOneValues.discussObjective
                      ? `${oneToOneValues.discussObjective}`
                      : ""
                  }
                  name="discussObjective"
                  valueName="discussObjective"
                  control={control}
                />
              </InputContainer>
              {showObjectives && (
                <InputContainer
                  labelText="Which objective would you like to talk about?"
                  required
                  forLabel="objectives"
                  errorText={errors.objectives && errors.objectives.message}
                >
                  <Controller
                    as={
                      <Select
                        mode="multiple"
                        size="large"
                        placeholder="Select Objective"
                        className={`${styles.form_input} ${errors.objectives ? styles.error : ""}`}
                        style={{ width: "100%" }}
                        onChange={handleObjectivesSelection}
                        onSelect={handleObjectivesSelection}
                        getPopupContainer={(triggerNode) => triggerNode}
                        onKeyPress={preventFormDefault}
                        onDeselect={() => setIsDirtyForm(true)}
                        defaultValue={
                          editMode && oneToOneValues && oneToOneValues.objectives
                            ? oneToOneValues.objectives
                            : undefined
                        }
                        notFoundContent={
                          <MultiSelectNoContent message="You currently have no objectives to select" />
                        }
                      >
                        {objectivesData}
                      </Select>
                    }
                    name="objectives"
                    valueName="objectives"
                    rules={{
                      required: "Must not be blank",
                      validate: () => {
                        const objectives = getValues("objectives");
                        if (objectives.length === 0) {
                          return "Must not be blank";
                        }
                        return true;
                      },
                    }}
                    control={control}
                  />
                </InputContainer>
              )}
              {showObjectives && (
                <InputContainer
                  labelText="Please give an overview of what you would like to discuss."
                  required
                  forLabel="objectivesDesc"
                  errorText={errors.objectivesDesc && errors.objectivesDesc.message}
                >
                  <textarea
                    name="objectivesDesc"
                    id="objectivesDesc"
                    onPaste={inputKeydown}
                    className={`${styles.form_textarea} ${
                      errors.objectivesDesc ? styles.error : ""
                    }`}
                    defaultValue={editMode && oneToOneValues ? oneToOneValues.objectivesDesc : ""}
                    onChange={(e) => {
                      inputKeydown();
                      onInputChange("objectivesDesc", e.target.value, false);
                    }}
                    ref={register({
                      required: "Must not be blank",
                    })}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        onInputChange("objectivesDesc", e.target.value, true);
                      }
                      a11yGrowTextarea(e, "objectivesDesc");
                    }}
                  />
                </InputContainer>
              )}
              <InputContainer
                labelText="Is there any particular development goal(s) you would like to discuss at this 1-2-1?"
                required
                forLabel="discussDevelopmentGoal"
                errorText={errors.discussDevelopmentGoal && errors.discussDevelopmentGoal.message}
              >
                <a
                  className={styles.link}
                  href={`${webUrl}/my-objectives/PDP`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Click here to view your development goals
                </a>
                <Controller
                  as={
                    <RadioSelect
                      onObjectivesToDiscussChange={handleDiscussObjectivesChange}
                      value={`${oneToOneValues.discussDevelopmentGoal}`}
                      name="discussDevelopmentGoal"
                    />
                  }
                  defaultValue={
                    editMode && oneToOneValues && oneToOneValues.discussDevelopmentGoal
                      ? `${oneToOneValues.discussDevelopmentGoal}`
                      : ""
                  }
                  name="discussDevelopmentGoal"
                  valueName="discussDevelopmentGoal"
                  control={control}
                />
              </InputContainer>
              {showDevelopmentGoals && (
                <InputContainer
                  labelText="Which development goals would you like to talk about?"
                  required
                  forLabel="developmentGoals"
                  errorText={errors.developmentGoals && errors.developmentGoals.message}
                >
                  <Controller
                    as={
                      <Select
                        mode="multiple"
                        size="large"
                        placeholder="Select Development Goal"
                        className={`${styles.form_input} ${
                          errors.developmentGoals ? styles.error : ""
                        }`}
                        style={{ width: "100%" }}
                        onChange={handleObjectivesSelection}
                        onSelect={handleObjectivesSelection}
                        getPopupContainer={(triggerNode) => triggerNode}
                        onDeselect={() => setIsDirtyForm(true)}
                        defaultValue={
                          editMode && oneToOneValues && oneToOneValues.developmentGoals
                            ? oneToOneValues.developmentGoals
                            : undefined
                        }
                        notFoundContent={
                          <MultiSelectNoContent message="You currently have no development goals to select" />
                        }
                      >
                        {developmentGoalsData}
                      </Select>
                    }
                    name="developmentGoals"
                    valueName="developmentGoals"
                    rules={{
                      required: "Must not be blank",
                      validate: () => {
                        const developmentGoals = getValues("developmentGoals");
                        if (developmentGoals.length === 0) {
                          return "Must not be blank";
                        }
                        return true;
                      },
                    }}
                    control={control}
                  />
                </InputContainer>
              )}
              {showDevelopmentGoals && (
                <InputContainer
                  labelText="Please give an overview of what you would like to discuss."
                  required
                  forLabel="developmentGoalsDesc"
                  errorText={errors.developmentGoalsDesc && errors.developmentGoalsDesc.message}
                >
                  <textarea
                    name="developmentGoalsDesc"
                    id="developmentGoalsDesc"
                    onPaste={inputKeydown}
                    className={`${styles.form_textarea} ${
                      errors.developmentGoalsDesc ? styles.error : ""
                    }`}
                    defaultValue={
                      editMode && oneToOneValues ? oneToOneValues.developmentGoalsDesc : ""
                    }
                    onChange={(e) => {
                      inputKeydown();
                      onInputChange("developmentGoalsDesc", e.target.value, false);
                    }}
                    ref={register({
                      required: "Must not be blank",
                    })}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        onInputChange("developmentGoalsDesc", e.target.value, true);
                      }
                      a11yGrowTextarea(e, "developmentGoalsDesc");
                    }}
                  />
                </InputContainer>
              )}
              <Text
                wrapper="h3"
                type="subtitle"
                style={{
                  fontSize: "20px",
                  lineHeight: "140%",
                  letterSpacing: "0.0015em",
                  marginTop: "32px",
                }}
              >
                Wellbeing check-in
              </Text>
              <InputContainer
                labelText="Please mark how you are feeling on the below scale:"
                forLabel="wellBeingFeeling"
                errorText={errors.wellBeingFeeling && errors.wellBeingFeeling.message}
              >
                <Controller
                  as={
                    <SliderSelect
                      onChangeHandler={handleWellbeingSelection}
                      value={oneToOneValues && oneToOneValues.wellBeingFeeling}
                    />
                  }
                  defaultValue={editMode && oneToOneValues ? oneToOneValues.wellBeingFeeling : 0}
                  name="wellBeingFeeling"
                  valueName="wellBeingFeeling"
                  control={control}
                />
              </InputContainer>
              <InputContainer
                labelText="Any additional comments?"
                forLabel="additionalComments"
                errorText={errors.additionalComments && errors.additionalComments.message}
              >
                <textarea
                  name="additionalComments"
                  id="additionalComments"
                  onPaste={inputKeydown}
                  ref={register()}
                  className={`${styles.form_textarea} ${
                    errors.additionalComments ? styles.error : ""
                  }`}
                  defaultValue={editMode && oneToOneValues ? oneToOneValues.additionalComments : ""}
                  onChange={(e) => {
                    inputKeydown();
                    onInputChange("additionalComments", e.target.value, false);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      onInputChange("additionalComments", e.target.value, true);
                    }
                    a11yGrowTextarea(e, "additionalComments");
                  }}
                />
              </InputContainer>
            </div>
          </form>
        </div>
        <div className={styles.bottom_row}>
          <Text type="body" wrapper="span" fontSize="18px">
            Once you’ve submitted your notes, your manager will be able to see your comments, which
            should give you both some great talking points for your next 1-2-1.
          </Text>
          <div className={styles.button_actions}>
            <div>
              {!editMode && (
                <CreateOneToOneButtons
                  status="new"
                  saveOneToOne={onSave}
                  isDisableActions={isDisableActions}
                  isDirtyForm={isDirtyForm}
                  onSubmit={() => {
                    onSubmit(getValues());
                  }}
                />
              )}
              {editMode && (
                <EditOneToOneButtons
                  status={
                    oneToOneValues && oneToOneValues.status === "submitted" ? "editing" : "draft"
                  }
                  onSaveDraft={onSaveDraft}
                  isDisableActions={isDisableActions}
                  isDirtyForm={isDirtyForm}
                  onEdit={() => {
                    onEdit(getValues());
                  }}
                />
              )}
            </div>
          </div>
        </div>
      </Wrapper>
    </>
  );
};
export default withRouter(CreateOneToOne);
